import * as React from 'react'
import Layout from '$views/components/Layout'
import { Text } from '$views/components/Text'
import { Link } from '$views/components/Link'
import { Block } from '$views/components'
import { Footer } from '$views/components/Footer'
import { styled } from '$utils/theme'
import { TableCookies } from '$views/Cookies/components/TableCookies'
import { EventSystem } from '$utils/services/eventSystem/eventSystem'
import { EventSystemName } from '$utils/services/eventSystem/eventSystemName'

export const StyledFooter = styled.div`
  margin: auto;
  margin-top: 7rem;
  width: 100%;
  background-color: ${p => p.theme.colors.darkGrey};
  ${p => p.theme.media.onlyMobile`
    margin-top: 6rem;
  `};
`

const Cookies: React.FC = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const dispatchCookieEvent = () => {
    EventSystem.dispatchAppEvent(EventSystemName.cookieSettings, '')
  }

  return (
    <>
      <Layout>
        <Text header marginTop="large">
          Política de cookies
        </Text>
        <Block marginTop="small">
          <Text title>¿Qué son las cookies?</Text>
          <Text marginTop="mini">
            Las cookies son unos archivos de texto que se alojan en el terminal del usuario visitante y que almacenan y
            recuperan información sobre la navegación. Aunque la funcionalidad de las cookies es siempre la misma, la
            finalidad puede variar de forma que existen distintos tipos de cookies. Más adelante en este documento, se
            indica el uso concreto que hacemos de cada una.
          </Text>
          <Text subheader marginTop="mini">
            Más sobre cookies:
          </Text>
          <Block marginTop="mini">
            <Link href="https://es.wikipedia.org/wiki/Cookie_%28inform%C3%A1tica%29" target="_blank">
              Entrada en la Wikipedia sobre las cookies
            </Link>
          </Block>
          <Block marginTop="mini">
            <Link href="https://tools.ietf.org/html/rfc6265" target="_blank">
              Documento técnico explicativo sobre las cookies
            </Link>
          </Block>
          <Block marginTop="mini">
            <Link href="https://www.allaboutcookies.org/es/" target="_blank">
              AllAboutCookies.com
            </Link>
          </Block>
        </Block>
        <Block marginTop="medium">
          <Text title>Aceptar, denegar o revocar el consentimiento para la instalación de cookies</Text>
          <Text marginTop="mini">
            Tenemos habilitado un gestor de consentimiento por el cual al entrar en nuestro sitio web podrás libremente
            aceptar, denegar o configurar la instalación de cookies. Así pues, pueden darse las siguientes situaciones:
          </Text>
          <Block as="ul" marginTop="mini">
            <Text as="li" marginTop="mini">
              <Text weight="medium" as="span" color="menu">
                Consentimiento
              </Text>
              : Si pulsas el botón de “Aceptar”, consientes la instalación de cookies de forma que todas las cookies
              seleccionadas serán instaladas en tu equipo.
            </Text>
            <Text as="li" marginTop="mini">
              <Text weight="medium" as="span" color="menu">
                Configuración
              </Text>
              : Si pulsas en el botón de “Gestionar o rechazar cookies” aparecerá un desplegable en el que podrás
              indicar expresamente qué tipología de cookies consientes que sean instaladas y cuáles no. Únicamente se
              instalarán las cookies seleccionadas.
            </Text>
            <Text as="li" marginTop="mini">
              <Text weight="medium" as="span" color="menu">
                Rechazar
              </Text>
              : Si pulsas en el botón de “Gestionar o rechazar cookies” podrás rechazar la aplicación de todas las
              cookies distintas de las necesarias.
            </Text>
          </Block>
        </Block>
        <Block marginTop="medium">
          <Text title>Bloqueo y eliminación de cookies</Text>
          <Text marginTop="mini">
            Por regla general los navegadores disponen de diversas opciones de configuración en relación a las cookies,
            que permiten ajustar diversos niveles de privacidad, de forma que, por ejemplo, se denieguen todas las
            cookies que pueda enviar un sitio web como este o incluso se eliminen todas las cookies que pudieran haberse
            guardado. Para modificar dichos parámetros, puedes consultar la ayuda del navegador que utilices o solicitar
            más información a sus desarrolladores.
          </Text>
          <Text marginTop="mini">
            En cualquier caso, desde aquí puedes acceder a las instrucciones de los navegadores más populares de
            escritorio y móviles.
          </Text>
          <Block marginTop="mini">
            <Link href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank">
              Google Chrome
            </Link>
            <Text as="span">, </Text>
            <Link
              href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias?redirectlocale=es&redirectslug=Habilitar+y+deshabilitar+cookies"
              target="_blank"
            >
              Mozilla Firefox
            </Link>
            <Text as="span">, </Text>
            <Link href="https://support.microsoft.com/es-es/hub/4338813/windows-help" target="_blank">
              Microsoft Edge
            </Link>
            <Text as="span"> y </Text>
            <Link href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank">
              Safari
            </Link>
          </Block>
          <Block marginTop="mini">
            <Link href="https://support.apple.com/es-es/HT201265" target="_blank">
              IOS
            </Link>
            <Text as="span">, </Text>
            <Link href="https://www.wikihow.com/Disable-Cookies#Android_Devices" target="_blank">
              Android
            </Link>
          </Block>
          <Text marginTop="mini">
            En el caso de que el usuario restrinja o bloquee alguna o todas de las cookies del presente sitio web, es
            posible que alguna de las funcionalidades o servicios prestados de la página no estén disponibles.
          </Text>
        </Block>
        <Block marginTop="medium">
          <Text title>Navegación privada o de incógnito</Text>
          <Text marginTop="mini">
            Finalmente, al margen de la posibilidad de restringir o eliminar las cookies la mayoría de los navegadores
            web permiten la visita a las páginas mediante la modalidad conocida como “
          </Text>
          <Link
            href="https://support.mozilla.org/es/kb/navegacion-privada-Firefox-no-guardar-historial-navegacion"
            target="_blank"
          >
            navegación privada
          </Link>
          <Text as="span">, de </Text>
          <Link href="https://support.google.com/chrome/answer/95464?co=GENIE.Platform%3DDesktop&hl=es" target="_blank">
            incógnito
          </Link>
          <Text as="span">, </Text>
          <Link href="https://support.google.com/chrome/answer/95464?co=GENIE.Platform%3DDesktop&hl=es" target="_blank">
            inPrivate
          </Link>
          <Text as="span">
            ”. Dicha funcionalidad implica que al cerrar en navegador/pestaña se eliminen los datos de la navegación que
            hayan podido almacenarse o generarse (entre ellos, las cookies).
          </Text>
        </Block>
        <Block marginTop="medium">
          <Text title>Tipos de cookies</Text>
          <Block marginTop="mini">
            <Text weight="medium" as="span">
              Necesaria
            </Text>
            <Text as="span">
              : Ayudan a hacer una página web utilizable activando funciones básicas como la navegación en la página y
              el acceso a áreas seguras de la página web. La página web no puede funcionar adecuadamente sin estas
              cookies.
            </Text>
          </Block>
          <Block marginTop="mini">
            <Text weight="medium" as="span">
              Preferencias
            </Text>
            <Text as="span">
              : Permiten a la página web recordar toda aquella información que cambia la forma en que la página se
              comporta o el aspecto que tiene, como el idioma preferido o la región.
            </Text>
          </Block>
          <Block marginTop="mini">
            <Text weight="medium" as="span">
              Estadística
            </Text>
            <Text as="span">
              : Ayudan a los propietarios de páginas web a comprender cómo interactúan los visitantes con las páginas
              web reuniendo y proporcionando información de forma anónima.
            </Text>
          </Block>
          <Block marginTop="mini">
            <Link href="#" onClick={dispatchCookieEvent}>
              Ver y gestionar mi configuración de cookies
            </Link>
          </Block>
        </Block>
        <Block marginTop="medium">
          <Text title>Cookies que utilizamos en Familiados</Text>
          <Text marginTop="small">
            Las cookies de nuestra web se asocian únicamente a un usuario anónimo y a su ordenador. Nunca proporcionan
            ni recogen datos que permitan obtener datos personales del usuario.
          </Text>
          <Block marginTop="mini">
            <Text as="span" weight="medium">
              Cookies de Google Analytics (__utma, __utmb, __utmc, __utmz)
            </Text>
            <Text as="span"> Estas cuatro cookies son servidas por </Text>
            <Link href="https://marketingplatform.google.com/about/analytics/" target="_blank">
              Google Analytics
            </Link>
            <Text as="span">
              {' '}
              para recoger diversa información sobre la navegación del usuario por nuestro site. Por ejemplo, la
              ubicación del visitante, detalles de la visita realizada (tiempo, páginas vistas, etc.). Además de
              bloquear estas cookies por medio del navegador, el usuario puede utilizar este{' '}
            </Text>
            <Link href="https://tools.google.com/dlpage/gaoptout" target="_blank">
              Complemento
            </Link>
            <Text as="span">
              {' '}
              facilitado por la propia Google para inhabilitar el servicio de Google Analytics en su visita.
            </Text>
          </Block>
          <Block marginTop="mini">
            <Text weight="medium" as="span">
              Cookies técnicas de la plataforma web (cookieconsent_dismissed, PHPSESSID)
            </Text>
            <Text as="span">
              {' '}
              Estas cookies son empleadas por la página y tienen como objetivo permitir la visita a la página.
            </Text>
          </Block>
          <Text marginTop="mini">
            Las cookies se instalan en el dispositivo del usuario al hacer scroll o navegar por la web y/o aceptar su
            instalación pulsando en el botón de Aceptar.
          </Text>
          <Text marginTop="mini" marginBottom="mini">
            En Familiados utilizamos las siguientes cookies:
          </Text>
          <TableCookies />
        </Block>
      </Layout>
      <StyledFooter>
        <Footer />
      </StyledFooter>
    </>
  )
}

export default Cookies



// WEBPACK FOOTER //
// ./src/views/Cookies/Cookies.tsx